/**
 * Signup referral: set when a visitor successfully loads a public score at /s/:id.
 * Unlike localStorage key "s", this is NOT cleared by pronunciation import flow.
 */
export const LS_PENDING_SIGNUP_REFERRER_SENTENCE_SCORE_ID = 'pendingSignupReferrerSentenceScoreId';

/** Legacy key used only for importing a shared score into Custom Sentence (pronunciation page). */
export const LS_PUBLIC_SCORE_IMPORT_ID = 's';
